import { createSlice } from '@reduxjs/toolkit'
import { getBlocks, saveBlock, createBlock, deleteBlock } from './blockActions'

const initialState = {
  blocks: [],
  loading: false,
  loadingError: false,
  savingError: false,
  saving: false,
  saved: false,
  savedBlock: {},
  deleting: false,
  deleted: false,
  deletingError: false,
}

function isRejectedAction(action) {
  return action.type.endsWith('rejected')
}

const blockSlice = createSlice({
  name: 'blocks',
  initialState,
  reducers: {
    clear: (state) => {
      state.saved = false
      state.savingError = false
      state.loadingError = false
      state.savedBlock = {}
      state.deleting = false
      state.deleted = false
      state.deletingError = false
    },
  },

  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(getBlocks.fulfilled, (state, { payload }) => {
        state.loading = false
        state.blocks = payload
        /*payload.forEach((i) => {
          state.blocks[i.id] = i
        })*/
      })
      .addCase(getBlocks.pending, (state) => {
        state.loading = true
        state.loadingError = null
        state.savingError = null
      })
      .addCase(getBlocks.rejected, (state, { payload }) => {
        state.loading = false
        state.loadingError = payload
      })
      .addCase(saveBlock.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(saveBlock.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.savedBlock = payload
        state.saved = true
        state.saving = false
      })
      .addCase(saveBlock.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(createBlock.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(createBlock.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.savedBlock = payload
        state.saved = true
        state.saving = false
      })
      .addCase(createBlock.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(deleteBlock.pending, (state) => {
        state.deleting = true
        state.deletingError = null
        state.deleted = false
      })
      .addCase(deleteBlock.fulfilled, (state) => {
        state.deletingError = null
        state.deleted = true
        state.deleting = false
      })
      .addCase(deleteBlock.rejected, (state, { payload }) => {
        state.deleting = false
        state.deletingError = payload
        state.deleted = false
      })
    /*.addMatcher(
        isRejectedAction,
        // `action` will be inferred as a RejectedAction due to isRejectedAction being defined as a type guard
        (state, { payload }) => {
          state.loading = false
          state.error = payload
        },
      )*/
  },
})

export const { clear } = blockSlice.actions
export default blockSlice.reducer
